import { ThemeContext, type Theme } from "@/context/ThemeContext";
import { useEffect, useState, type ReactNode } from "react";

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>("light");

  useEffect(() => {
    (async () => {
      const saved = localStorage.getItem("theme") as Theme;
      if (saved) {
        setTheme(saved)
        // console.log(`Set theme to stored one -${saved}`)
      }
      else {
        const prefersDark = window.matchMedia(
          "(prefers-color-scheme: dark)",
        ).matches;
        // console.log(`User prefers dark? ${String(prefersDark)}`);
        
        setTheme(prefersDark ? "dark" : "light");
      }
    })();
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
